module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [_c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'DebtorList'
      }
    }
  }, [_vm._v("Dłużnicy")])], 1)]), _vm._v(" "), _c('b-container', {
    staticClass: "col page-element"
  }, [(_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.deletedItem) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v(_vm._s(_vm.deletedItem['@id']) + " deleted.")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_c('thead', [_c('tr', [_c('td', [_c('b-form-input', {
    staticClass: "form-control input-search",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.filter.name),
      callback: function($$v) {
        _vm.$set(_vm.filter, "name", $$v)
      },
      expression: "filter.name"
    }
  }), _c('svg-icon', {
    attrs: {
      "name": "search"
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    staticClass: "form-control input-search",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.filter.nip),
      callback: function($$v) {
        _vm.$set(_vm.filter, "nip", $$v)
      },
      expression: "filter.nip"
    }
  }), _c('svg-icon', {
    attrs: {
      "name": "search"
    }
  })], 1), _vm._v(" "), _c('td', [_c('dropdown-search', {
    attrs: {
      "id": "status-dropdown",
      "elements": _vm.cessionStatus,
      "showEmpty": true
    },
    model: {
      value: (_vm.filter.cessionAvailable),
      callback: function($$v) {
        _vm.$set(_vm.filter, "cessionAvailable", $$v)
      },
      expression: "filter.cessionAvailable"
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    staticClass: "form-control input-search",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.filter.address),
      callback: function($$v) {
        _vm.$set(_vm.filter, "address", $$v)
      },
      expression: "filter.address"
    }
  }), _c('svg-icon', {
    attrs: {
      "name": "search"
    }
  })], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "no-wrap"
  }, [_c('my-button', {
    attrs: {
      "variant": "info",
      "action": _vm.getItems
    }
  }), _vm._v(" "), _c('my-button', {
    attrs: {
      "icon": "back",
      "variant": "primary",
      "action": _vm.resetFilter
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('name'),
    on: {
      "click": function($event) {
        return _vm.setOrder('name')
      }
    }
  }, [_vm._v("Nazwa")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('nip'),
    on: {
      "click": function($event) {
        return _vm.setOrder('nip')
      }
    }
  }, [_vm._v("NIP")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('cessionAvailable'),
    on: {
      "click": function($event) {
        return _vm.setOrder('cessionAvailable')
      }
    }
  }, [_vm._v("Cesja")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('address'),
    on: {
      "click": function($event) {
        return _vm.setOrder('address')
      }
    }
  }, [_vm._v("Adres")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('deptPLN'),
    on: {
      "click": function($event) {
        return _vm.setOrder('deptPLN')
      }
    }
  }, [_vm._v("Zadłużenie (PLN)")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('deptEUR'),
    on: {
      "click": function($event) {
        return _vm.setOrder('deptEUR')
      }
    }
  }, [_vm._v("Zadłużenie (EUR)")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'DebtorShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item['name']))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'DebtorShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item['nip']))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'DebtorShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(_vm._f("translate")(item['cessionAvailable'])))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'DebtorShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item.address.postalCode) + " " + _vm._s(item.address.city) + ", ul. " + _vm._s(item.address.street) + " " + _vm._s(item.address.number))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'DebtorShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item['deptPLN']))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'DebtorShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item['deptEUR']))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon",
      attrs: {
        "to": {
          name: 'DebtorUpdate',
          params: {
            id: item['id']
          }
        },
        "title": "Edytuj"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "edit"
      }
    })], 1)], 1)])
  }), 0)])]), _vm._v(" "), _c('pagination', {
    attrs: {
      "changePage": _vm.changePage,
      "currentPage": _vm.currentPage,
      "pagination": _vm.pagination
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89731a76","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/debtor/List.vue
// module id = 832
// module chunks = 0